import { mapActions, mapGetters } from 'vuex';
import domtoimage from 'dom-to-image';
import base64Img from 'base64-img';

// Force image URLs to https before fetching them for base64 inlining.
// An http:// (or protocol-relative) CDN URL gets redirected to https, and a
// redirect on the (CORS-preflighted) request is rejected by the browser
// ("Failed to fetch"), which would otherwise leave the thumbnail without its
// background. https:// avoids the redirect entirely.
function toHttps(url) {
  if (!url || typeof url !== 'string') return url;
  return url
    .trim()
    .replace(/^http:\/\//i, 'https://')
    .replace(/^\/\//, 'https://');
}

const styles = [
  'display/plugins/ticker/ticker.css',
  'display/plugins/clock/clock.css',
  'display/static/css/fonts.css',
  'display/static/css/countdown.css',
  'display/plugins/dateHeure/dateHeure.css',
  'display/plugins/weather/weather.css',
  'display/static/css/pays-icon.css',
];

export default {
  computed: {
    ...mapGetters({}),
  },
  methods: {
    ...mapActions('slides', ['updateSlideThumbnail']),
    ...mapActions('segments', ['updateSegmentThumbnail', 'updateSegmentListThumbnail']),

    async initClone() {
      const iframe = document.querySelector('.gjs-frame');
      const { width, height } = iframe.getBoundingClientRect();

      const cloneWrapper = document.createElement('iframe');
      cloneWrapper.style.position = 'absolute';
      cloneWrapper.style['z-index'] = '-9999';
      cloneWrapper.style.top = '-9999px';
      cloneWrapper.style.left = '-9999px';
      cloneWrapper.style.width = (width > 0 ? width : 1280) + 'px';
      cloneWrapper.style.height = (height > 0 ? height : 720) + 'px';
      cloneWrapper.id = 'clone';

      document.body.appendChild(cloneWrapper);
      setTimeout(() => {
        const body = $('#clone')
          .contents()
          .find('body');

        setTimeout(async () => {
          const contentWrapper = document.createElement('div');
          contentWrapper.className = 'wrapper';
          contentWrapper.style["background-color"] = '#fff';

          body.append(contentWrapper);

          let xhr = [];
          for (let i = 0; i < styles.length; i++) {
            await (function (i) {
              xhr[i] = new XMLHttpRequest();
              let url = styles[i];
              xhr[i].open('GET', url, true);
              xhr[i].onreadystatechange = function () {
                if (xhr[i].readyState === 4 && xhr[i].status === 200) {
                  var style = document.createElement('style');
                  style.type = 'text/css';
                  style.innerHTML = xhr[i].responseText;
                  body.append(style);
                }
              };
              xhr[i].send();
            })(i);
          }
        }, 500);
      }, 500);
    },
    async generateSlideThmbnail(uid) {
      this.cloneNode();
      await this.handleStyle();
      await this.handleInlineStyle();
      await this.handleImgTags();
      await this.handlePlayers();
      await this.handleVideos();
      await this.renderSlide(uid);
    },
    cloneNode() {
      const previewFrame = $('#gjs iframe').contents();
      const domforImage = previewFrame
        .find('body')[0]
        .innerHTML.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/g, '');

      const cloneBody = $('#clone')
        .contents()
        .find('.wrapper');

      cloneBody.html(domforImage);

      this.domforImage = cloneBody[0];
      let back = getComputedStyle(document.querySelector('#gjs iframe').contentWindow.document.querySelector("body"))["background-color"];
      if (back)
        this.domforImage.style["background-color"] = back;
    },
    async handleStyle() {
      const styles = this.domforImage.getElementsByTagName('style');
      for (let i = 0; i < styles.length; i++) {
        const style = styles[i];
        await new Promise(mainResolve => {
          this.replaceAsync(
            style.innerHTML,
            /\bhttps?:[^)''"]+\.(?:jpe?g|png|gif|svg)(?![a-z/])/g,
            async img => {
              return await new Promise(resolve => {
                base64Img.requestBase64(toHttps(img), function (err, res, body) {
                  if (err) {
                    console.error('ERRRR', err);
                  }
                  // Fall back to the original URL when inlining fails so the
                  // background is never replaced with `undefined` (and stripped).
                  resolve(body || img);
                });
              });
            },
          ).then(replacedString => {
            style.innerHTML = replacedString;
            mainResolve();
          });
        });
      }
    },
    async handleInlineStyle() {
      const divs = this.domforImage.getElementsByTagName('*');
      for (let i = 0; i < divs.length; i++) {
        const div = divs[i];
        let img = div.style.backgroundImage.split('"')[1];

        if (/\.(?:jpe?g|png|gif|svg)/g.test(img)) {
          await new Promise(resolve => {
            base64Img.requestBase64(toHttps(img), function (err, res, body) {
              if (err) {
                console.error('ERRRR', err);
              }
              // Keep the original URL when inlining fails instead of "undefined".
              div.style.backgroundImage = `url("${body || img}")`;
              resolve();
            });
          });
        }
      }
    },
    async handleImgTags() {
      const images = this.domforImage.getElementsByTagName('img');
      for (let i = 0; i < images.length; i++) {
        const img = images[i];

        if (/\.(?:jpe?g|png|gif|svg)/g.test(img.src)) {
          const originalSrc = img.src;
          await new Promise(resolve => {
            base64Img.requestBase64(toHttps(originalSrc), function (err, res, body) {
              if (err) {
                console.error('ERRRR', err);
              }
              // Keep the original src when inlining fails instead of "undefined".
              img.src = body || originalSrc;
              resolve();
            });
          });
        }
      }
    },
    // Problème 12 : dom-to-image sérialise le DOM dans un <foreignObject> SVG, où
    // un élément <video> n'est jamais rasterisé — la vignette d'un écran vidéo
    // ressortait donc entièrement blanche. On remplace la balise par une image
    // fixe (le `poster` de la vidéo, à défaut un fond noir) surmontée de l'icône
    // « play », ce que dom-to-image sait rendre.
    async replaceVideoTag(video) {
      const { width, height } = video.getBoundingClientRect();

      const placeholder = document.createElement('div');
      placeholder.setAttribute('style', video.getAttribute('style') || '');
      placeholder.style.position = video.style.position || 'relative';
      placeholder.style.width = width ? width + 'px' : '100%';
      placeholder.style.height = height ? height + 'px' : '100%';
      placeholder.style.backgroundColor = '#000';
      placeholder.style.backgroundSize = 'contain';
      placeholder.style.backgroundPosition = 'center';
      placeholder.style.backgroundRepeat = 'no-repeat';
      placeholder.style.display = 'flex';
      placeholder.style.alignItems = 'center';
      placeholder.style.justifyContent = 'center';

      const poster = video.getAttribute('poster');
      if (poster) {
        // Même inlining base64 que handleImgTags() : une URL distante n'est pas
        // chargée depuis le <foreignObject>.
        const inlined = await new Promise(resolve => {
          base64Img.requestBase64(toHttps(poster), function(err, res, body) {
            resolve(body || poster);
          });
        });
        placeholder.style.backgroundImage = `url("${inlined}")`;
      }

      placeholder.appendChild(this.buildPlayIcon());
      video.parentNode.replaceChild(placeholder, video);
    },

    buildPlayIcon() {
      const playBtn = document.createElement('img');
      playBtn.src =
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBjbGFzcz0iIj48Zz48cGF0aCBkPSJNMjU2LDBDMTE0LjYxNywwLDAsMTE0LjYxNSwwLDI1NnMxMTQuNjE3LDI1NiwyNTYsMjU2czI1Ni0xMTQuNjE1LDI1Ni0yNTZTMzk3LjM4MywwLDI1NiwweiBNMzQ0LjQ4LDI2OS41N2wtMTI4LDgwICBjLTIuNTksMS42MTctNS41MzUsMi40My04LjQ4LDIuNDNjLTIuNjY4LDAtNS4zNC0wLjY2NC03Ljc1OC0yLjAwOEMxOTUuMTU2LDM0Ny4xNzIsMTkyLDM0MS44MiwxOTIsMzM2VjE3NiAgYzAtNS44MiwzLjE1Ni0xMS4xNzIsOC4yNDItMTMuOTkyYzUuMDg2LTIuODM2LDExLjMwNS0yLjY2NCwxNi4yMzgsMC40MjJsMTI4LDgwYzQuNjc2LDIuOTMsNy41Miw4LjA1NSw3LjUyLDEzLjU3ICBTMzQ5LjE1NiwyNjYuNjQxLDM0NC40OCwyNjkuNTd6IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iYWN0aXZlLXBhdGgiIHN0eWxlPSJmaWxsOiNGRkZGRkYiIGRhdGEtb2xkX2NvbG9yPSIjMDAwMDAwIj48L3BhdGg+PC9nPiA8L3N2Zz4=';
      playBtn.style.width = '200px';
      playBtn.style.maxWidth = '40%';
      playBtn.style.opacity = '0.85';
      return playBtn;
    },

    async handlePlayers() {
      // Les <video> sont traités à part : l'overlay ci-dessous était ajouté à
      // l'intérieur de la balise, où le navigateur ne rend jamais rien.
      const videos = this.domforImage.querySelectorAll('video');
      for (let i = videos.length - 1; i >= 0; i--) {
        await this.replaceVideoTag(videos[i]);
      }

      const players = this.domforImage.querySelectorAll('[data-gjs-type="player"],[data-gjs-type="video_mp4"]');
      for (let i = 0; i < players.length; i++) {
        const player = players[i];

        const { width, height, top, left } = player.getBoundingClientRect();

        const playBtn = this.buildPlayIcon();

        const overlay = document.createElement('div');
        overlay.style.position = 'fixed';
        overlay.style.backgroundColor = 'transparent';
        overlay.style.width = width + 'px';
        overlay.style.height = height + 'px';
        overlay.style.top = top + 'px';
        overlay.style.left = left + 'px';
        overlay.style.display = 'flex';
        overlay.style.alignItems = 'center';
        overlay.style.justifyContent = 'center';
        overlay.style.zIndex = '99';

        if (player.childNodes.length > 0) {
          player.removeChild(player.childNodes[0]);
          player.appendChild(overlay);
        } else {
          player.parentNode.appendChild(overlay)
        }
        overlay.appendChild(playBtn);
        // player.appendChild(overlay);
      }
    },
    async handleVideos() {
      const videos = this.domforImage.querySelectorAll('video');
      for (let i = 0; i < videos.length; i++) {
        const video = videos[i];
        video.mute = true;
      }
    },
    async replaceAsync(str, regex, asyncFn) {
      const promises = [];
      str.replace(regex, (match, ...args) => {
        const promise = asyncFn(match, ...args);
        promises.push(promise);
      });
      const data = await Promise.all(promises);
      return str.replace(regex, () => data.shift());
    },

    // dom-to-image walks document.styleSheets to inline web fonts, and reading
    // cssRules throws a SecurityError on any sheet the browser considers
    // unreadable: cross-origin ones (the animate.css that v-animate-css pulls
    // from cdnjs) and ones rejected by strict MIME checking. It swallows the
    // error but logs it on every capture. Their rules can't be inlined anyway,
    // so hide them behind a filtered styleSheets getter for the duration of the
    // capture. Shadowing the getter rather than detaching the <link> nodes
    // avoids re-fetching the sheets and restyling the live page.
    hideUnreadableStyleSheets() {
      const readable = Array.prototype.filter.call(document.styleSheets, sheet => {
        try {
          // Throws for sheets we're not allowed to read.
          // eslint-disable-next-line no-unused-expressions
          sheet.cssRules;
          return true;
        } catch (e) {
          return false;
        }
      });

      Object.defineProperty(document, 'styleSheets', {
        configurable: true,
        get: () => readable,
      });

      return () => {
        delete document.styleSheets;
      };
    },

    renderSlide(uid) {
      const cloneBody = $('#clone')
        .contents()
        .find('.wrapper');

      setTimeout(() => {
        const restoreStyleSheets = this.hideUnreadableStyleSheets();
        domtoimage
          .toJpeg(this.domforImage)
          .then(thumbnail => {
            restoreStyleSheets();
            var img = new Image();
            img.src = thumbnail;
            // document.body.appendChild(img);
            const slide = { uid, thumbnail };

            if (thumbnail !== "data:,") {
              if (this.$route.name === 'segment') {
                this.updateSlideThumbnail(slide);
              } else
                if (this.$route.name === 'ListSegment') {

                  this.updateSegmentListThumbnail(slide);
                } else {
                  this.updateSegmentThumbnail(slide);
                }
            }

            cloneBody.html('');
          })
          .catch(function (e) {
            restoreStyleSheets();
            cloneBody.html('');
            console.error('error: ', e);
          });
      }, 500);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/GrapesMixinHelpers.js